import { ReligionEnum } from "../../Types/Enums/ReligionEnum";

export const RELIGION_CONFIG = [
  { id: ReligionEnum.NONE, labels: { 0: "Ninguna / Ateísmo", 1: "None / Atheism" } },
  { id: ReligionEnum.CATHOLIC, labels: { 0: "Catolicismo", 1: "Catholicism" } },
  { id: ReligionEnum.PROTESTANT, labels: { 0: "Cristianismo / Protestante", 1: "Christianity / Protestant" } },
  { id: ReligionEnum.JUDAISM, labels: { 0: "Judaísmo", 1: "Judaism" } },
  { id: ReligionEnum.ISLAM, labels: { 0: "Islam", 1: "Islam" } },
  { id: ReligionEnum.BUDDHISM, labels: { 0: "Budismo", 1: "Buddhism" } },
  { id: ReligionEnum.OTHER, labels: { 0: "Otro", 1: "Other" } }
];